import Button from "@components/ui/button";
import type { StaticEntityType } from "@config";
import { SlidePreview } from "@modules/slides-library/shared";
import { IconX } from "@tabler/icons-react";
import type { CSSProperties } from "react";
import { previewScale } from "../components/version-row";

const scale = previewScale(266);

export const GenerationCompleteToast = ({
  slide,
  style,
  onReview,
  onDismiss,
}: {
  slide: unknown | null;
  style: CSSProperties;
  onReview: () => void;
  onDismiss: () => void;
}) => (
  <div className="tw-flex tw-w-[298px] tw-flex-col tw-gap-4 tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-py-4 tw-shadow-md tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/5">
    <div className="tw-flex tw-flex-col tw-px-4">
      <div className="tw-flex tw-items-center tw-gap-2">
        <h3 className="tw-m-0 tw-flex tw-h-8 tw-flex-1 tw-items-center tw-text-lg tw-font-semibold tw-leading-[1.4] tw-text-blue">
          Congrats!
        </h3>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={onDismiss}
          className="tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-lg tw-text-blue-500 hover:tw-bg-blue-50 hover:tw-text-blue focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-violet-700"
        >
          <IconX className="tw-size-4" />
        </button>
      </div>
      <p className="tw-m-0 tw-text-sm tw-text-blue-500">
        Your new converted Storydoc is ready.
      </p>
    </div>
    {slide != null && (
      <div className="tw-px-4">
        <div
          className="story tw-overflow-hidden tw-rounded-lg tw-bg-white tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/10"
          style={style}
        >
          <SlidePreview
            slide={slide as StaticEntityType}
            isIntersecting
            shouldRender
            className="tw-rounded-none tw-shadow-none !tw-outline-0"
            style={scale}
          />
        </div>
      </div>
    )}
    <div className="tw-px-4">
      <Button className="tw-w-full" onClick={onReview}>
        Review and edit
      </Button>
    </div>
  </div>
);
